import React from 'react'
import { HashRouter, Link, Route, Routes } from 'react-router-dom'
import { MenuUnificadoNight } from '../menu/MenuUnificadoNight'
import { MenuUnificadoNightOnline } from '../menu/MenuUnificadoNightOnline'

export const MenuUnificadoRouterNight = () => {

  const basename = document.querySelector('base')?.getAttribute('href') ?? '/'  

  return (
    <HashRouter basename={basename}>
        <Routes>
            <Route path="/*" element={<MenuUnificadoNightOnline />} />
            <Route path="/vermenuonline" element={<MenuUnificadoNight />} />     
        </Routes>
    </HashRouter>
  )
}
